<template>
    <div class="flexbox flexbox-center-small-device" :style="{'justify-content': positionClass()}">
        <ul class="paginate" v-show="value">
            <li @click="previousPage()" :class="{'disabled': disabledClassPrevious}">
                <a>Forrige</a>
            </li>
            <li v-if="showPaging" v-for="(page, index) in pages" :key="index" :class="{'active': activePage === index + 1}" @click="clickedPage(index + 1)">
                <a>{{index + 1}}</a>
            </li>
            <li @click="nextPage()" :class="{'disabled': disabledClassNext}">
                <a>Næste</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'paginate',
    props: {
        value: {
            type: [Array, Object]
        },
        records: {
            type: [Number, String],
            default: 0
        },
        pageSize: {
            type: [Number, String],
            default: 0
        },
        position: {
            type: String,
            default: 'left'
        },
        changePage: {
            type: Function
        },
        showPaging: {
            type: Boolean,
            default: true
        },
        selectedTab: {
            type: String
        },
        activePage: {
            type: Number
        }
    },
    data () {
        return {
            model: this.value,
            paginationStart: 1
        }
    },
    computed: {
        pages () {
            if (!this.records) {
                return []
            } else {
                return this.range(this.paginationStart, this.pagesInCurrentChunk)
            }
        },
        totalPages () {
            return this.records ? Math.ceil(this.records / this.pageSize) : 1
        },
        pagesInCurrentChunk () {
            return this.totalPages - this.paginationStart + 1
        },
        disabledClassNext () {
            if (this.activePage === this.totalPages) {
                return true
            }

            return false
        },
        disabledClassPrevious () {
            if (this.activePage === 1) {
                return true
            }

            return false
        }
    },
    methods: {
        clickedPage (page) {
            this.changePage(page)
        },
        previousPage () {
            if (this.activePage !== 1) {
                this.changePage(this.activePage - 1)
            }
        },
        nextPage () {
            if (this.activePage !== this.totalPages) {
                this.changePage(this.activePage + 1)
            }
        },
        range (start, count) {
            return Array.apply(0, Array(count)).map((element, index) => {
                return index + start
            })
        },
        positionClass () {
            if (this.position === 'left') {
                return 'flex-start'
            }

            if (this.position === 'center') {
                return 'center'
            }

            if (this.position === 'right') {
                return 'flex-end'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/paginate/paginate.vue